import Vue from 'vue'

module.export = Vue.component('editlesseemodal',
    {
        name: 'editlessee',
        props: {
            data: Object
        },
        components: {},
        data: function () {
            return {
                alerts: [],
                EditModel: Object.assign({}, this.data)
            };
        },
        methods: {
            addAlert: function (event) {
                this.alerts = [];
                this.alerts.push(event);
            },
            clearAlert: function (index) {
                this.alerts.splice(index, 1);
            },
            save: function (e) {
                e.preventDefault();
                const _this = this;
                _this.clearAlert();
                $.ajax({
                    type: 'POST',
                    url: '/Lessees/Edit',
                    data: JSON.stringify({
                        lesseeNumber: _this.EditModel.LesseeNumber,
                        lesseeName: _this.EditModel.LesseeName,
                        // EmailAddress attribute is used, null is valid but empty string is not
                        csdEmail: _this.EditModel.CsdEmail === "" ? null : _this.EditModel.CsdEmail
                    }),
                    success: function (data) {
                        if (data.success) {
                            _this.close();
                            location.reload();
                        } else {
                            _this.addAlert(
                                {
                                    "message": `Could not edit lessee: ${data.data}`,
                                    "isSuccess": false
                                });
                        }
                    },
                    error: function (data) {
                        this.addAlert(
                            {
                                "message": 'Could not edit lessee due to a server error',
                                "isSuccess": false
                            });
                    },
                    contentType: "application/json",
                    dataType: 'json'
                });
            },
            escapeClose: function (e) {
                if (e.keyCode == 27) {
                    this.close();
                }
            },
            close: function () {
                this.clearAlert();
                this.EditModel = Object.assign({}, this.data);
                $('#edit-lessee--change-lessee').modal('hide');

                // Enable save button again.
                $("#saveButton").removeAttr("disabled");
            }
        }
    });